import { createAction, props } from '@ngrx/store';
import { OrderStatistic } from '../../helpers/statistics.helper';
import { ProductStatistic } from '../../commons/models/product';
import { ZoneStatistic } from '../../commons/models/zone';

export const loadOrderStatistics = createAction('[Statistics] Load Order Statistics',props<{ startDate: Date, endDate: Date, isDelivery: boolean, isTakeAway: boolean, tenant_id?: number | null }>());
export const loadOrderStatisticsCompleted = createAction('[Statistics] Load Order Statistics Completed',props<{ orders: OrderStatistic[], startDate: Date, endDate: Date, isDelivery: boolean, isTakeAway: boolean, tenant_id?: number | null }>());
export const loadOrderStatisticsFailed = createAction('[Statistics] Load Order Statistics Failed',props<{ error: any }>());

// **Caricamento delle statistiche dei prodotti**
export const loadProductStatistics = createAction('[Statistics] Load Product Statistics',props<{ startDate: Date, endDate: Date, tenant_id?: number | null }>());
export const loadProductStatisticsCompleted = createAction('[Statistics] Load Product Statistics Completed',props<{ products: ProductStatistic[], startDate: Date, endDate: Date, tenant_id?: number | null }>());
export const loadProductStatisticsFailed = createAction('[Statistics] Load Product Statistics Failed',props<{ error: any }>());

// **Caricamento delle statistiche delle zone**
export const loadZoneStatistics = createAction('[Statistics] Load Zone Statistics',props<{ startDate: Date, endDate: Date, tenant_id?: number | null }>());
export const loadZoneStatisticsCompleted = createAction('[Statistics] Load Zone Statistics Completed',props<{ zones: ZoneStatistic[], startDate: Date, endDate: Date, tenant_id?: number | null }>());
export const loadZoneStatisticsFailed = createAction(
  '[Statistics] Load Zone Statistics Failed',
  props<{ error: any }>()
);

// **Aggiornamento delle date**
export const changeStatisticsDateRange = createAction(
  '[Statistics] Change Date Range',
  props<{ startDate: Date, endDate: Date }>()
);

// **Filtri**
export const changeOrderFilters = createAction(
  '[Statistics] Change Order Filters',
  props<{ isDelivery: boolean, isTakeAway: boolean }>()
);

export const changeTenantFilter = createAction(
  '[Statistics] Change Tenant Filter',
  props<{ tenant_id?: number | null }>()
);

export const loadTotalStatistics = createAction(
  '[Statistics] Load Total Statistics',
  props<{ startDate: string, endDate: string }>()
);

export const loadTotalStatisticsSuccess = createAction(
  '[Statistics] Load Total Statistics Success',
  props<{ incomeTotal: number, ordersTotal: number }>()
);

export const loadTotalStatisticsFailure = createAction(
  '[Statistics] Load Total Statistics Failure',
  props<{ error: any }>()
);

export const loadStatisticsCompleted = createAction(
  '[Statistics] Load Statistics Completed',
  props<{ orders: any; topSelling: any; zones: any }>()
);

export const loadStatisticsFailed = createAction(
  '[Statistics] Load Total Statistics Failure',
  props<{ error: any }>()
);

